// src/hooks/sale/useSalePermissions.ts

import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { getSalePermissions } from '../../features/sale/history/salePermissions';
import { useAuthUser } from '../auth/useAuthUser';
import { RootState } from '../../store/store';

/**
 * Permisos del Historial de Ventas, derivados del set de permisos del JWT
 * (`state.auth.permissions`). El rol solo se usa para el break-glass de SUPPORT
 * y para el evento de retorno (ADMIN/SUPPORT).
 */
export const useSalePermissions = () => {
  const { hasRole } = useAuthUser();
  const granted = useSelector((state: RootState) => state.auth.permissions || []);

  return useMemo(() => {
    const set = new Set(granted);
    return getSalePermissions(hasRole, (permission) => set.has(permission));
  }, [granted, hasRole]);
};
